"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Round = function Round(x) {
  var round = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.01;

  if (isNaN(x) || isNaN(round)) {
    return NaN;
  }

  if (typeof round !== 'number' || !Number.isInteger(Math.log10(round))) {
    return Math.round(x);
  }

  var _round = 1 / round;

  return Math.round(x * _round) / _round;
};

exports.default = Round;